<template>
    <v-card elevation="8" class="ma-5 mt-10" style="border-top: solid; border-top-color: #10303D; border-top-width: 3px;">
        <v-container fluid>
            <v-layout row justify-center>
                <v-flex class="item" xs12 md12 ma-4>
                    <h2><strong>Relatório de Propriedades Ativas</strong></h2>
                </v-flex>
            </v-layout>

            <v-form ref="form">
                <v-layout row wrap justify-start class="pl-2">
                    <v-flex class="item" lg2 md2 sm6 xs11 pa-1>
                        <menu-datepicker
                            label="Ativas em" :rules="[campoObrigatorio]"
                            outlined dateType="month"
                            v-model="mesRelatorio"
                            display-format="MM/Y"
                            :max-date="maxDate"
                        />
                    </v-flex>
                    <v-flex class="item" lg2 md1 sm6 xs12 pa-2 pt-3>
                        <v-btn id="search" dark rounded color="primary" @click="loadDados" :loading="loading">
                            <span class="marginSpan"> Gerar </span>
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-form>
        </v-container>
    </v-card>
</template>

<script>
import MenuDatepicker from '../../modules/common/components/MenuDatepicker'
import { campoObrigatorio } from '../../filters/rules'
import moment from "moment";
export default {
    name: 'RelatorioPropriedadesAtivas',
    components: {
        MenuDatepicker,
    },
    data() {
        return {
            mesRelatorio: null,
            loading: false,
        }
    },
    computed: {
        urlAPIEstabelecimento() {
            return this.$store.state.urlAPIEstabelecimento
        },
        maxDate() {
            return moment().endOf('month').format('YYYY-MM-DD')
        }
    },
    methods: {
        campoObrigatorio,
        loadDados () {
            if (this.$refs.form.validate())
            {
                this.loading = true
                this.$axios.get(this.urlAPIEstabelecimento + 'relatorio/rpa', {
                    params: {
                        dtInicio: moment(this.mesRelatorio, "MM/YYYY").startOf('month').format('YYYY-MM-DD'),
                        dtFim: moment(this.mesRelatorio, "MM/YYYY").endOf('month').format('YYYY-MM-DD'),
                    }
                })
                .then( response => {
                    window.open(this.urlAPIEstabelecimento + 'relatorio/' + response.data.file,   "_blank",
                        "resizable,scrollbars,status");
                })
                .catch((error) => {
                    this.$store.commit('setSnack', {type: 'error', msg : error})
                })
                .finally(() => {
                    this.loading = false
                })
            }
        }
    },
}
</script>